export function isCloneable(object) {
    if (typeof object !== 'object' || object === null) {
        return false;
    }
    return typeof object.clone === 'function';
}
/**
 * Clones supported containers recursively and delegates to Cloneable implementations.
 * Other objects are shallow-copied with their actual prototype and own enumerable properties.
 */
export function cloneObject(obj) {
    if (isCloneable(obj)) {
        return (obj).clone(); // paranthesis fix type checking for some reason?
    }
    if (Array.isArray(obj)) {
        return (obj).map((e) => {
            return cloneObject(e);
        });
    }
    if (obj instanceof Map) {
        // Transform into a normal object to conform to MapDecoders expected format
        const encodedObj = new Map();
        for (const [key, value] of obj) {
            const k = cloneObject(key);
            encodedObj.set(k, cloneObject(value));
        }
        return encodedObj;
    }
    if (obj instanceof Date) {
        return new Date(obj);
    }
    if (typeof obj === 'object' && obj !== null) {
        return Object.defineProperties(Object.create(Object.getPrototypeOf(obj)), Object.getOwnPropertyDescriptors({ ...obj }));
    }
    // Singular value
    return obj;
}
//# sourceMappingURL=Cloneable.js.map